import Icon from "rc-app/components/Icons";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Customer (lead/buyer) homepage. Shows exactly three tiles — Projects,
// Analytics, Profile — mirroring the ABA/ASA/Agent home layout (same tile
// size, centered) but with buyer-facing hero copy. Responsive layout matches
// ClientHomePage: flows + scrolls on mobile (dvh), fitted on desktop.
const CustomerHomePage: React.FC = () => {
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();
  const base = slug ? `/c/${slug}` : "";

  useEffect(() => {
    if (slug) localStorage.setItem("agencySlug", slug);
  }, [slug]);

  const menuItems = [
    { title: "Projects", icon: "ic-client-projects", path: `${base}/p/library` },
    { title: "Analytics", icon: "ic-client-analytics", path: `${base}/analytics` },
    { title: "Profile", icon: "ic-client-profile", path: `${base}/profile` },
  ];

  return (
    <div className="min-h-[calc(100dvh-64px)] bg-gradient-to-b from-[#1C2C3A] to-[#1E4F52] flex flex-col">
      {/* Hero Section */}
      <div className="flex-shrink-0 flex flex-col md:flex-row px-4 pt-6 pb-5 md:py-2 md:h-[300px] bg-[#222F3C] items-center justify-between">
        <div className="flex flex-col w-full md:w-auto justify-center gap-2 md:gap-4">
          <div className="max-w-2xl">
            <h1 className="text-white text-lg md:text-3xl lg:text-5xl font-semibold mb-1 md:mb-4 leading-tight">
              EXPLORE YOUR
              <br />
              FUTURE HOME
            </h1>
            <p className="text-white text-xs md:text-xl font-medium">
              Discover and tour properties curated just for you
            </p>
          </div>
        </div>

        {/* static image */}
        <div className="hidden md:block h-full w-1/2 max-w-[740px] rounded-t-lg">
          <img
            src={`${process.env.REACT_APP_UPLOADED_URL}/realestate/client-home-hero.jpg`}
            alt="Home"
            className="w-full h-full object-cover overflow-hidden rounded-t-lg"
          />
        </div>
      </div>

      {/* Menu Cards */}
      <div className="flex-1 min-h-0 container mx-auto px-4 py-5 md:py-3 md:px-8 flex items-start md:items-center">
        {/* Same 6-up tile width as the other homepages so the three customer
            tiles render at an identical size, centered. */}
        <div className="w-full flex flex-wrap justify-center gap-3 md:gap-6">
          {menuItems.map((item) => (
            <div
              key={item.title}
              onClick={() => navigate(item.path)}
              className="grow-0 shrink-0 basis-[calc((100%_-_0.75rem)/2)] md:basis-[calc((100%_-_3rem)/3)] lg:basis-[calc((100%_-_7.5rem)/6)] border-2 border-[#FFFFFF] rounded-2xl p-3 md:p-5 cursor-pointer hover:bg-[#254555] transition-all flex flex-col items-center justify-center"
            >
              <div className="w-12 h-12 md:w-24 md:h-24 mb-1.5 md:mb-3">
                <Icon name={item.icon} className="w-full h-full" />
              </div>
              <h3 className="text-white text-sm md:text-lg font-medium text-center">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerHomePage;
